import { getConfig } from '@superbet-group/web.lib.config';
import { Country } from '@superbet-group/web.types';

const Wiki = {
    Help: 'Help',
    AboutUs: 'AboutUs',
    DataProtection: 'DataProtection',
    PrivacyPolicy: 'PrivacyPolicy',
    CookiePolicy: 'CookiePolicy',
    ResponsibleGaming: 'ResponsibleGaming',
    AntiLaunderingPolicy: 'AntiLaunderingPolicy',
    GameRules: 'GameRules',
    TermsAndConditions: 'TermsAndConditions',
    Careers: 'Careers',
    Cooperation: 'Cooperation',
    PressOffice: 'PressOffice',
    AbcPlayer: 'AbcPlayer',
    BettingRules: 'BettingRules',
    BettingAndGameRules: 'BettingAndGameRules',
    ComplaintsProcedure: 'ComplaintsProcedure',
    SuperBonus: 'SuperBonus',
    Licenses: 'Licenses',
    TermsOfPayment: 'TermsOfPayment',
    MarketingPreferences: 'MarketingPreferences',
    PaymentMethods: 'PaymentMethods',
    Pep: 'Pep',
    SuperAdvantage: 'SuperAdvantage',
    NewRegulations: 'NewRegulations',
    NewRegulationsUnderage: 'NewRegulationsUnderage',
    NapoleonLicenses: 'NapoleonLicenses',
    ReferAFriend: 'ReferAFriend',
    CustomerSupport: 'CustomerSupport',
    InsuranceSubstitution: 'InsuranceSubstitution',
} as const;
type Wiki = typeof Wiki[keyof typeof Wiki];

const countryPathsMap: Record<Country, Record<Wiki, string>> = {
    [Country.Ro]: {
        [Wiki.AboutUs]: 'despre-noi',
        [Wiki.Help]: 'ajutor',
        [Wiki.DataProtection]: 'declaratia-de-confidentialitate',
        [Wiki.CookiePolicy]: 'politica-de-utilizare-a-cookie-urilor',
        [Wiki.PrivacyPolicy]: 'declaratia-de-confidentialitate',
        [Wiki.ResponsibleGaming]: 'joc-responsabil',
        [Wiki.AntiLaunderingPolicy]: 'politica-impotriva-spalarii-banilor',
        [Wiki.GameRules]: 'regulamente-de-joc',
        [Wiki.TermsAndConditions]: 'termeni-si-conditii',
        [Wiki.Careers]: '',
        [Wiki.Cooperation]: '',
        [Wiki.PressOffice]: '',
        [Wiki.AbcPlayer]: '',
        [Wiki.BettingRules]: '',
        [Wiki.BettingAndGameRules]: '',
        [Wiki.ComplaintsProcedure]: '',
        [Wiki.SuperBonus]: 'super-bonus',
        [Wiki.Licenses]: '',
        [Wiki.TermsOfPayment]: '',
        [Wiki.MarketingPreferences]: '',
        [Wiki.PaymentMethods]: 'metode-de-plata',
        [Wiki.Pep]: '',
        [Wiki.SuperAdvantage]: 'superavantaj',
        [Wiki.NewRegulations]: '',
        [Wiki.NewRegulationsUnderage]: '',
        [Wiki.NapoleonLicenses]: '',
        [Wiki.ReferAFriend]: '',
        [Wiki.CustomerSupport]: '',
        [Wiki.InsuranceSubstitution]: 'asigurare-la-schimbare',
    },
    [Country.RoNapoleon]: {
        [Wiki.AboutUs]: 'despre-noi',
        [Wiki.Help]: 'ajutor',
        [Wiki.DataProtection]: 'declaratia-de-confidentialitate',
        [Wiki.CookiePolicy]: 'politica-de-utilizare-a-cookie-urilor',
        [Wiki.PrivacyPolicy]: 'declaratia-de-confidentialitate',
        [Wiki.ResponsibleGaming]: 'joc-responsabil',
        [Wiki.AntiLaunderingPolicy]: 'politica-impotriva-spalarii-banilor',
        [Wiki.GameRules]: 'regulamente-de-joc',
        [Wiki.TermsAndConditions]: 'termeni-si-conditii',
        [Wiki.Careers]: '',
        [Wiki.Cooperation]: '',
        [Wiki.PressOffice]: '',
        [Wiki.AbcPlayer]: '',
        [Wiki.BettingRules]: '',
        [Wiki.BettingAndGameRules]: '',
        [Wiki.ComplaintsProcedure]: '',
        [Wiki.SuperBonus]: 'super-bonus',
        [Wiki.Licenses]: '',
        [Wiki.TermsOfPayment]: '',
        [Wiki.MarketingPreferences]: '',
        [Wiki.PaymentMethods]: 'metode-de-plata',
        [Wiki.Pep]: '',
        [Wiki.SuperAdvantage]: 'superavantaj',
        [Wiki.NewRegulations]: '',
        [Wiki.NewRegulationsUnderage]: '',
        [Wiki.NapoleonLicenses]: '',
        [Wiki.ReferAFriend]: '',
        [Wiki.CustomerSupport]: '',
        [Wiki.InsuranceSubstitution]: '',
    },
    [Country.Pl]: {
        [Wiki.AboutUs]: 'o-nas',
        [Wiki.Help]: 'pomoc',
        [Wiki.DataProtection]: 'polityka-prywatnosci',
        [Wiki.CookiePolicy]: 'polityka-cookies',
        [Wiki.PrivacyPolicy]: 'polityka-prywatnosci',
        [Wiki.ResponsibleGaming]: 'odpowiedzialna-gra',
        [Wiki.AntiLaunderingPolicy]: '',
        [Wiki.GameRules]: '',
        [Wiki.TermsAndConditions]: 'regulamin',
        [Wiki.Careers]: 'kariera',
        [Wiki.Cooperation]: 'wspolpraca-agencyjna',
        [Wiki.PressOffice]: 'biuro-prasowe',
        [Wiki.AbcPlayer]: 'vademecum-gracza',
        [Wiki.BettingRules]: '',
        [Wiki.BettingAndGameRules]: '',
        [Wiki.ComplaintsProcedure]: '',
        [Wiki.SuperBonus]: 'super-bonus',
        [Wiki.Licenses]: '',
        [Wiki.TermsOfPayment]: '',
        [Wiki.MarketingPreferences]: '',
        [Wiki.PaymentMethods]: 'metody-platnosci-online',
        [Wiki.Pep]: '',
        [Wiki.SuperAdvantage]: 'super-przewaga',
        [Wiki.NewRegulations]: '',
        [Wiki.NewRegulationsUnderage]: '',
        [Wiki.NapoleonLicenses]: '',
        [Wiki.ReferAFriend]: '',
        [Wiki.CustomerSupport]: '',
        [Wiki.InsuranceSubstitution]: 'bezpieczna-zmiana',
    },
    [Country.Com]: {
        [Wiki.AboutUs]: 'about-us',
        [Wiki.Help]: 'help',
        [Wiki.DataProtection]: '',
        [Wiki.CookiePolicy]: 'cookie-policy',
        [Wiki.PrivacyPolicy]: 'privacy-notice',
        [Wiki.ResponsibleGaming]: 'responsible-gaming',
        [Wiki.AntiLaunderingPolicy]: '',
        [Wiki.GameRules]: '',
        [Wiki.TermsAndConditions]: 'terms-and-conditions',
        [Wiki.Careers]: '',
        [Wiki.Cooperation]: '',
        [Wiki.PressOffice]: '',
        [Wiki.AbcPlayer]: '',
        [Wiki.BettingRules]: 'sports-rules',
        [Wiki.BettingAndGameRules]: 'betting-and-game-rules',
        [Wiki.ComplaintsProcedure]: '',
        [Wiki.SuperBonus]: 'super-bonus',
        [Wiki.Licenses]: '',
        [Wiki.TermsOfPayment]: '',
        [Wiki.MarketingPreferences]: '',
        [Wiki.PaymentMethods]: 'payment-methods',
        [Wiki.Pep]: '',
        [Wiki.SuperAdvantage]: 'superadvantage',
        [Wiki.NewRegulations]: '',
        [Wiki.NewRegulationsUnderage]: '',
        [Wiki.NapoleonLicenses]: '',
        [Wiki.ReferAFriend]: '',
        [Wiki.CustomerSupport]: '',
        [Wiki.InsuranceSubstitution]: '',
    },
    [Country.Br]: {
        [Wiki.AboutUs]: 'sobre-nos',
        [Wiki.Help]: 'ajuda',
        [Wiki.DataProtection]: '',
        [Wiki.CookiePolicy]: 'politica-de-cookies',
        [Wiki.PrivacyPolicy]: 'aviso-de-privacidade-online',
        [Wiki.ResponsibleGaming]: 'jogo-responsavel',
        [Wiki.AntiLaunderingPolicy]: '',
        [Wiki.GameRules]: '',
        [Wiki.TermsAndConditions]: 'termos-e-condicoes',
        [Wiki.Careers]: '',
        [Wiki.Cooperation]: '',
        [Wiki.PressOffice]: '',
        [Wiki.AbcPlayer]: '',
        [Wiki.BettingRules]: '',
        [Wiki.BettingAndGameRules]: 'regras-de-apostas-e-jogos',
        [Wiki.ComplaintsProcedure]: '',
        [Wiki.SuperBonus]: 'supermultipla',
        [Wiki.Licenses]: 'anti-lavagem-de-dinheiro',
        [Wiki.TermsOfPayment]: '',
        [Wiki.MarketingPreferences]: '',
        [Wiki.PaymentMethods]: 'metodos-de-pagamento',
        [Wiki.Pep]: '',
        [Wiki.SuperAdvantage]: 'superplacar',
        [Wiki.NewRegulations]: '',
        [Wiki.NewRegulationsUnderage]: '',
        [Wiki.NapoleonLicenses]: '',
        [Wiki.ReferAFriend]: '',
        [Wiki.CustomerSupport]: 'procedimentos-ouvidoria',
        [Wiki.InsuranceSubstitution]: 'substituicao-garantida',
    },
    [Country.BrSocial]: {
        [Wiki.AboutUs]: '',
        [Wiki.Help]: '',
        [Wiki.DataProtection]: '',
        [Wiki.CookiePolicy]: '',
        [Wiki.PrivacyPolicy]: 'privacy-notice-social',
        [Wiki.ResponsibleGaming]: '',
        [Wiki.AntiLaunderingPolicy]: '',
        [Wiki.GameRules]: '',
        [Wiki.TermsAndConditions]: 'terms-and-conditions-social',
        [Wiki.Careers]: '',
        [Wiki.Cooperation]: '',
        [Wiki.PressOffice]: '',
        [Wiki.AbcPlayer]: '',
        [Wiki.BettingRules]: '',
        [Wiki.BettingAndGameRules]: '',
        [Wiki.ComplaintsProcedure]: '',
        [Wiki.SuperBonus]: '',
        [Wiki.Licenses]: '',
        [Wiki.TermsOfPayment]: '',
        [Wiki.MarketingPreferences]: '',
        [Wiki.PaymentMethods]: '',
        [Wiki.Pep]: '',
        [Wiki.SuperAdvantage]: '',
        [Wiki.NewRegulations]: '',
        [Wiki.NewRegulationsUnderage]: '',
        [Wiki.NapoleonLicenses]: '',
        [Wiki.ReferAFriend]: '',
        [Wiki.CustomerSupport]: '',
        [Wiki.InsuranceSubstitution]: '',
    },
    [Country.Rs]: {
        [Wiki.AboutUs]: 'o-nama',
        [Wiki.Help]: 'pomoc',
        [Wiki.DataProtection]: '',
        [Wiki.CookiePolicy]: 'politika-kolacica',
        [Wiki.PrivacyPolicy]: 'politika-privatnosti',
        [Wiki.ResponsibleGaming]: 'odgovorno-igranje',
        [Wiki.AntiLaunderingPolicy]: '',
        [Wiki.GameRules]: '',
        [Wiki.TermsAndConditions]: 'pravila-igre',
        [Wiki.Careers]: '',
        [Wiki.Cooperation]: '',
        [Wiki.PressOffice]: '',
        [Wiki.AbcPlayer]: '',
        [Wiki.BettingRules]: '',
        [Wiki.BettingAndGameRules]: '',
        [Wiki.ComplaintsProcedure]: 'politika-zalbi',
        [Wiki.SuperBonus]: 'ekstra-bonus',
        [Wiki.Licenses]: '',
        [Wiki.TermsOfPayment]: 'opsti-uslovi-uplate',
        [Wiki.MarketingPreferences]: '',
        [Wiki.PaymentMethods]: 'metode-placanja',
        [Wiki.Pep]: 'funkcioner',
        [Wiki.SuperAdvantage]: 'superprednost',
        [Wiki.NewRegulations]: '',
        [Wiki.NewRegulationsUnderage]: '',
        [Wiki.NapoleonLicenses]: '',
        [Wiki.ReferAFriend]: '',
        [Wiki.CustomerSupport]: '',
        [Wiki.InsuranceSubstitution]: 'sigurne-izmene',
    },
    [Country.Be]: {
        [Wiki.AboutUs]: '',
        [Wiki.Help]: 'help',
        [Wiki.DataProtection]: '',
        [Wiki.CookiePolicy]: 'cookie-policy',
        [Wiki.PrivacyPolicy]: 'privacy-policy',
        [Wiki.ResponsibleGaming]: 'responsible-gaming',
        [Wiki.AntiLaunderingPolicy]: '',
        [Wiki.GameRules]: '',
        [Wiki.TermsAndConditions]: 'terms-and-conditions',
        [Wiki.Careers]: '',
        [Wiki.Cooperation]: '',
        [Wiki.PressOffice]: '',
        [Wiki.AbcPlayer]: '',
        [Wiki.BettingRules]: '',
        [Wiki.BettingAndGameRules]: '',
        [Wiki.ComplaintsProcedure]: '',
        [Wiki.SuperBonus]: 'combine-and-conquer',
        [Wiki.Licenses]: 'licenses',
        [Wiki.TermsOfPayment]: '',
        [Wiki.MarketingPreferences]: '',
        [Wiki.PaymentMethods]: '',
        [Wiki.Pep]: '',
        [Wiki.SuperAdvantage]: '2up-promo',
        [Wiki.NewRegulations]: 'new-regulations',
        [Wiki.NewRegulationsUnderage]: '21-years-new-regulations',
        [Wiki.NapoleonLicenses]: 'licenses',
        [Wiki.ReferAFriend]: 'refer-a-friend',
        [Wiki.CustomerSupport]: '',
        [Wiki.InsuranceSubstitution]: 'safesub',
    },
    [Country.Bg]: {
        [Wiki.AboutUs]: 'about-us',
        [Wiki.Help]: 'help',
        [Wiki.DataProtection]: '',
        [Wiki.CookiePolicy]: 'cookie-policy',
        [Wiki.PrivacyPolicy]: 'privacy-notice',
        [Wiki.ResponsibleGaming]: 'responsible-gaming',
        [Wiki.AntiLaunderingPolicy]: '',
        [Wiki.GameRules]: '',
        [Wiki.TermsAndConditions]: 'terms-and-conditions',
        [Wiki.Careers]: '',
        [Wiki.Cooperation]: '',
        [Wiki.PressOffice]: '',
        [Wiki.AbcPlayer]: '',
        [Wiki.BettingRules]: '',
        [Wiki.BettingAndGameRules]: '',
        [Wiki.ComplaintsProcedure]: '',
        [Wiki.SuperBonus]: '',
        [Wiki.Licenses]: '',
        [Wiki.TermsOfPayment]: 'opsti-uslovi-uplate',
        [Wiki.MarketingPreferences]: '',
        [Wiki.PaymentMethods]: 'payment-methods',
        [Wiki.Pep]: '',
        [Wiki.SuperAdvantage]: '',
        [Wiki.NewRegulations]: '',
        [Wiki.NewRegulationsUnderage]: '',
        [Wiki.NapoleonLicenses]: '',
        [Wiki.ReferAFriend]: '',
        [Wiki.CustomerSupport]: '',
        [Wiki.InsuranceSubstitution]: '',
    },
};

export const WikiPath = countryPathsMap[getConfig().countrySpecific.country];
